"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M8.00049 12.0005C5.79449 12.0005 4.0005 10.2065 4.0005 8.00049C4.0005 5.79449 5.79449 4.0005 8.00049 4.0005C10.2065 4.0005 12.0005 5.79449 12.0005 8.00049C12.0005 10.2065 10.2065 12.0005 8.00049 12.0005ZM17.7075 16.2935L13.3115 11.8965C13.0795 11.6655 13.0125 11.3025 13.1785 11.0195C13.9105 9.77149 14.2085 8.2405 13.8455 6.6285C13.3485 4.4195 11.5675 2.6375 9.35649 2.1495C5.00049 1.1895 1.1895 5.00049 2.1495 9.35649C2.6375 11.5665 4.4195 13.3485 6.6275 13.8465C8.2395 14.2085 9.7695 13.9115 11.0165 13.1805C11.3015 13.0135 11.6665 13.0805 11.8995 13.3135L16.2935 17.7075C16.4885 17.9025 16.7445 18.0005 17.0005 18.0005C17.2565 18.0005 17.5125 17.9025 17.7075 17.7075C18.0985 17.3165 18.0985 16.6845 17.7075 16.2935Z",
    fill: "#727B7F"
  }));
};